import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      <div className="px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-open-line text-xl text-primary-400"></i>
                </div>
                <span className="text-lg font-heading font-bold text-background-50">韩漫之家</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                免费韩漫大全，好看的韩国漫画在线阅读平台。致力于为广大韩漫爱好者提供稳定、优质的阅读体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-categories" className="hover:text-primary-400 transition-colors">热门分类</a>
              </h4>
              <ul className="space-y-2">
                {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors flex items-center gap-2"
                    >
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className={`${cat.icon} text-xs`}></i>
                      </span>
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-links" className="hover:text-primary-400 transition-colors">快速链接</a>
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors">全部漫画</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系我们</a>
              </h4>
              <ul className="space-y-2 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-xs"></i>
                  </span>
                  hello@topshine.net.cn
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-shield-check-line text-xs"></i>
                  </span>
                  服务稳定值得信赖
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 韩漫之家 - 免费韩漫大全. 版权所有.
            </p>
            <p className="text-xs text-background-500">
              韩漫在线阅读平台，服务稳定值得信赖
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}